import React from 'react'
import {services} from './services-data'

import './Services.scss'

const Services = ({romana}: { romana: boolean }) =>
    <div className="bg-white">
        <div className="services">
            <p className="services-subtitle">{romana ? services['subtitle-ro'] : services['subtitle-de']}</p>
            <h1 className="services-header">{romana ? services['header-ro'] : services['header-de']}</h1>
            <div className="service">
                <div>
                    <h1 className="service-header">{romana ? services.wednesday['day-ro'] : services.wednesday['day-de']}</h1>
                    <p className="service-subtitle">{services.wednesday.time}</p>
                    <p className="service-subtitle">{romana ? services.wednesday['type-ro'] : services.wednesday['type-de']}</p>
                    <p className="service-text">{romana ? services.wednesday['description-ro'] : services.wednesday['description-de']}</p>
                </div>
                <div>
                    <h1 className="service-header">{romana ? services.sunday['day-ro'] : services.sunday['day-de']}</h1>
                    <p className="service-subtitle">{services.sunday.time1}</p>
                    <p className="service-subtitle">{romana ? services.sunday['type1-ro'] : services.sunday['type1-de']}</p>
                    <p className="service-text">{romana ? services.sunday['description1-ro'] : services.sunday['description1-de']}</p>
                    <p className="service-subtitle">{services.sunday.time2}</p>
                    <p className="service-subtitle">{romana ? services.sunday['type2-ro'] : services.sunday['type2-de']}</p>
                    <p className="service-text">{romana ? services.sunday['description2-ro'] : services.sunday['description2-de']}</p>
                </div>
                <div>
                    <h1 className="service-header">{romana ? services.friday['day-ro'] : services.friday['day-de']}</h1>
                    <p className="service-subtitle">{services.friday.time}</p>
                    <p className="service-subtitle">{romana ? services.friday['type-ro'] : services.friday['type-de']}</p>
                    <p className="service-text">{romana ? services.friday['description-ro'] : services.friday['description-de']}</p>
                </div>
            </div>
        </div>
    </div>


export default Services
